const setupFeeMap = {
    onetime: 'msetupfee',
    monthly: "msetupfee",
    quarterly: "qsetupfee",
    semiannually: "ssetupfee",
    annually: "asetupfee",
    biennially: "bsetupfee",
    triennially: "tsetupfee",
  };

  export default setupFeeMap